import React from 'react';
import { Grid, Box } from '@mui/material';

// components
import SalesOverview from './components/SalesOverview';
import YearlyBreakup from './components/YearlyBreakup';
import RecentTransactions from './components/RecentTransactions';
import ProductPerformance from './components/ProductPerformance';
import MonthlyEarnings from './components/MonthlyEarnings';
import PageContainer from '../../../components/Container/pageContainer';
import  Notification  from './components/nootification';
import FessStatus from './components/FessStatus';
import ShortAttendance from './components/ShortAttendance';
import NavigationButons from './components/NavigationButtons';
import FarsiNavigationButons from './components/farsiNavigationButton';
import { LanguageChecker } from '../../../constant/langaugechecker';


const Dashboard = () => {
const webSrn = localStorage.getItem('WebSrn')
  return (
    <PageContainer title="Wasily Technology" description="this is Dashboard">
      <Box>
        <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={12}>
                {
                  LanguageChecker() ?
                  <FarsiNavigationButons />
                    :
                    <NavigationButons />

                }

          </Grid>
          
          <Grid item xs={12} lg={6}>
                <RecentTransactions />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Notification />
          </Grid>
          {/* <Grid item xs={12} lg={12}>
            <SalesOverview />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FessStatus />
          </Grid>
          <Grid item xs={12} lg={6}> //This need to be done in recent future to collect the most short attendance students
            <ShortAttendance />
          </Grid> */}
          {/* <Grid item xs={12} lg={4}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <YearlyBreakup />
              </Grid>
              <Grid item xs={12}>
                <MonthlyEarnings />
              </Grid>
            </Grid>
          </Grid> */}
         
          {/* <Grid item xs={12} lg={8}>
            <ProductPerformance />
          </Grid> */}
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Dashboard;